import { Box, IconButton } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import { IconMinus, IconPlus } from '@tabler/icons-react'
import React, { useState } from 'react'
import useAppUtilities from '../../../../hooks/useAppUtilities'
import { IFaq } from '../../../../types/aboutTypes'
import {
  FAQAAnsTypography,
  FAQAQuestionTypography,
  FAQATypography,
  FAQAccordion,
  FAQAccordionDetails,
  FAQAccordionSummary,
  FAQDescriptionTypography,
} from '../styled/FAQs.styled'

interface IFAQsProps {
  faqData: IFaq[]
  title: string
  subTitle?: string
  my?: number
  titleTypography?: Variant
}

const FAQs: React.FC<IFAQsProps> = ({
  faqData,
  title,
  subTitle,
  my,
  titleTypography = 'h1',
}): JSX.Element => {
  const { theme } = useAppUtilities()
  const [expanded, setExpanded] = useState<string | null>(null)

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : null)
    }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        mb: { xs: 2, sm: 2.5, md: my ?? 14 },
        mt: { xs: 2, sm: 2.5, md: my ?? 14 },
      }}
    >
      <div>
        <FAQATypography variant={titleTypography}>{title}</FAQATypography>
        {subTitle && (
          <FAQDescriptionTypography>{subTitle}</FAQDescriptionTypography>
        )}
      </div>
      <Box
        sx={{
          maxWidth: '960px',
          width: '100%',
          mt: { xs: subTitle ? 0 : 2, md: subTitle ? 0 : 6 },
        }}
      >
        {faqData.map((faq) => {
          return (
            <FAQAccordion
              key={faq.id}
              expanded={expanded === faq.id}
              onChange={handleChange(faq.id)}
            >
              <FAQAccordionSummary
                isOpen={expanded === faq.id}
                expandIcon={
                  expanded === faq.id ? (
                    <IconButton
                      color="default"
                      size="small"
                      className="icon-btn-with-shadow"
                    >
                      <IconMinus stroke={2} color={theme.palette.grey[800]} />
                    </IconButton>
                  ) : (
                    <IconButton
                      color="bordered"
                      size="small"
                      className="icon-btn-with-shadow"
                    >
                      <IconPlus stroke={2} color={theme.palette.grey[800]} />
                    </IconButton>
                  )
                }
                aria-controls={`${faq.id}-content`}
                id={`${faq.id}-header`}
              >
                <FAQAQuestionTypography>{faq.question}</FAQAQuestionTypography>
              </FAQAccordionSummary>
              <FAQAccordionDetails
                sx={{
                  pt: { xs: 0, sm: '16px' },
                }}
              >
                <FAQAAnsTypography>{faq.answer}</FAQAAnsTypography>
              </FAQAccordionDetails>
            </FAQAccordion>
          )
        })}
      </Box>
    </Box>
  )
}

export default FAQs
